import type { MediaKind } from '@photos/shared'

/**
 * Corner marker showing a thumbnail is a 360 sphere rather than a flat photo.
 *
 * A wireframe globe — outline, equator, meridian — reads as "sphere" at badge
 * size where a "360" numeral would turn to mush. Drawn as strokes in
 * currentColor so it stays monochrome and inherits whatever the badge sets.
 *
 * Renders nothing for flat photos: once those exist they are the unremarkable
 * case and shouldn't carry a badge at all.
 */
export function MediaKindBadge({ kind }: { kind: MediaKind | undefined }): JSX.Element | null {
  // Records written before the field existed are all panoramas.
  if (kind === 'flat') return null

  return (
    // aria-label carries the meaning for screen readers; the tooltip below is
    // purely visual, so it is hidden from them to avoid announcing it twice.
    <span className="media-badge" role="img" aria-label="360° photo">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
        <circle cx="12" cy="12" r="9" />
        <ellipse cx="12" cy="12" rx="9" ry="3.75" />
        <ellipse cx="12" cy="12" rx="3.75" ry="9" />
      </svg>
      <span className="media-badge__tip" aria-hidden="true">
        360° photo
      </span>
    </span>
  )
}
